module.exports = __webpack_public_path__ + "static/media/SleepinessDuringDriving.f84f843c.png";